<div class="lum-c-extra-costs-edit">
  <table
    *ngIf="extraCostsForm.controls?.length; else empty"
    class="lum-c-extra-costs-edit__table lum-table lum-table--classic striped"
    [formGroup]="extraCostsForm"
  >
    <thead>
      <tr>
        <th>Memo</th>
        <th>Qty</th>
        <th>Unit Price</th>
        <th>Line Total</th>
        <th *ngIf="mode !== 'read'"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="
          let extraCost of extraCostsForm.controls;
          let i = index;
          trackBy: trackByControlValue
        "
      >
        <tr [formGroupName]="i">
          <td>
            <input
              formControlName="name"
              type="text"
              class="lum-input"
              [ngClass]="{ error: extraCost.get('name')?.invalid }"
              required
            />
          </td>
          <td>
            <input
              formControlName="quantity"
              type="number"
              class="lum-input text-right"
              lumDecimalLimit
            />
          </td>
          <td>
            <input
              formControlName="unitPrice"
              type="number"
              class="lum-input text-right"
            />
          </td>
          <td class="text-right">
            <strong>{{ extraCost.get('lineTotal').value | lumCurrency }}</strong>
          </td>
          <td *ngIf="mode !== 'read'">
            <button
              mat-icon-button
              color="warn"
              (click)="handleRemoveExtraCostRow($event, i)"
              ><mat-icon>delete</mat-icon></button
            >
          </td>
        </tr>
      </ng-container>

      <tr>
        <td class="text-right">
          <strong>Total</strong>
        </td>
        <td class="text-right">
          <strong>{{ totalQuantity | decimalPlaces }}</strong>
        </td>
        <td></td>
        <td class="text-right">
          <strong>{{ total | lumCurrency }}</strong>
        </td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <ng-template #empty>
    <lum-ui-empty-page
      class="mt-8"
      title="There are no extra costs to display."
    ></lum-ui-empty-page>
  </ng-template>

  <ng-container *ngIf="mode !== 'read'">
    <button
      class="lum-button lum-button--dotted w-100 mt-4"
      [matMenuTriggerFor]="menuExtraCosts"
    >
      Add Row(s)
    </button>
    <mat-menu
      #menuExtraCosts="matMenu"
      class="lum-mat-menu"
      yPosition="above"
      xPosition="before"
    >
      <button
        mat-menu-item
        type="button"
        (click)="handleAddExtraCostRows($event, 1)"
        >Add 1 Row</button
      >
      <button
        mat-menu-item
        type="button"
        (click)="handleAddExtraCostRows($event, 5)"
        >Add 5 Rows</button
      >
      <button
        mat-menu-item
        type="button"
        (click)="handleAddExtraCostRows($event, 10)"
        >Add 10 Rows</button
      >
      <button
        mat-menu-item
        type="button"
        (click)="handleAddExtraCostRows($event, 25)"
        >Add 25 Rows</button
      >
      <button
        mat-menu-item
        type="button"
        (click)="handleAddExtraCostRows($event, 50)"
        >Add 50 Rows</button
      >
    </mat-menu>
  </ng-container>
</div>
